import { typography } from "../mixins";

export const FormLabel = {
    baseStyle: {
        ...typography(14, 17, 500),
        color: "gray.500",
    },
};
